<template>
  <div class="report-type-switcher">
    <button
      v-for="report in availableReportOptions"
      :key="report.value"
      :class="{ active: report.value === selectedReport }"
      @click="changeReport(report.value)"
    >
      {{ parseTranslation(report.value) }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { reportOptions } from './report.constants'

import * as translationReportSelector from './ReportSelector.translations'

const { default: translations, ...translationKeys } = translationReportSelector

export default {
  props: {
    selectedReport: {
      required: true,
      type: String,
    },
    changeReport: {
      required: true,
      type: Function,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
    }
  },

  computed: {
    ...mapGetters(['isVisitorAccess']),

    availableReportOptions() {
      if (!this.isVisitorAccess) return reportOptions

      return reportOptions.filter(({ visitorAccess }) => visitorAccess)
    },
  },
}
</script>

<style lang="scss" scoped>
.report-type-switcher {
  @include flexMiddle;
  margin: 35px 0;

  > button {
    cursor: pointer;
    border: none;
    outline: none;
    text-transform: uppercase;
    color: #666;
    background: #ebeced;
    padding: 8px 40px;
    font-size: 1rem;
    font-weight: bold;
    letter-spacing: 3px;
    transition: color 0.5s ease, background-color 0.5s ease;

    @media (max-width: 760px) {
      padding: 8px 24px;
      font-size: rem(14);
      letter-spacing: 2px;
    }

    &:nth-of-type(1) {
      border-top-left-radius: 30px;
      border-bottom-left-radius: 30px;
    }
    /* This is for when we add back exports and reports tab */
    /* &:nth-of-type(2) {
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
    }
    &:nth-of-type(3) {
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
    } */
    &:last-of-type {
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
    }

    &:hover {
      background-color: #b3b3b3;
      color: #fff;
    }

    &.active {
      background: #0695fd;
      color: #fff;
    }
  }
}
</style>
